var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.942 20H4.062a4.142 4.142 0 0 1-2.872-1.146A3.838 3.838 0 0 1 0 16.09V7.91C0 6.874.428 5.88 1.19 5.146A4.142 4.142 0 0 1 4.062 4h15.88c1.077 0 2.11.412 2.872 1.146a3.838 3.838 0 0 1 1.19 2.765v8.178a3.838 3.838 0 0 1-1.19 2.765A4.142 4.142 0 0 1 19.942 20Zm-6.925-9.778-3.6-1.778v7.112L16.618 12l-3.6-1.778Z","fill":"#DEDEDE"}));
}

Youtube.defaultProps = {"width":"25","height":"24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
